

exports.__esModule = true;
exports.$Component = undefined;
exports.$populate = $populate;

var _angular = require('angular');

var _core = require('../core');

var _locale = require('../locale');

var _ng = require('./ng');

var _directive = require('./directive');

(0, _directive.$registerDirective)('prevent-default', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click', function (event) {
                event.preventDefault();
            });
        }
    };
});

(0, _directive.$registerDirective)('stop-propagation', function () {

    return {
        restrict: 'A',
        link: function link($scope, $element, $attrs) {
            $element.on('click keydown keypress keyup', function (event) {
                event.stopPropagation();
            });
        }
    };
});

(0, _directive.$registerDirective)('validate-submit', function () {

    return {
        link: function link($scope, $element, $attrs) {

            var $form = $element.closest('form');
            var form = $scope[$form.prop('name')];

            $element.on('click', function (event) {
                event.preventDefault();

                $form.addClass('validated');
                $scope.validated = true;
                form.$setSubmitted();

                if (form.$valid) {
                    try {
                        $scope.$eval($attrs.validateSubmit);
                    } catch (err) {
                        _angular.$injector.get('$exceptionHandler')(err);
                    }
                } else {
                    $form.find('.ng-invalid:first').focus();
                }
            });
        }
    };
});

function assertModelsRetrievedOrEmpty(items) {
    if (_core.$config.deploy.isLocal() || _core.$config.deploy.isStage()) {
        angular.forEach(items, function (item, name) {
            if (item instanceof _core.$Model) {
                if (item.meta.populated) {
                    throw new Error(name + ' is already populated. Please call .retrieve() to ensure your code is not relying on cache being present.');
                }
            }
        });
    }
}

function setUpComponentRoute($scope, $Component, angular) {
    var componentRoute = $scope.componentRoute;

    componentRoute.scope = $scope;

    componentRoute.scope.goto = function (route) {
        componentRoute.goto(route);
    };

    var parentRoute = componentRoute.parent;

    if (parentRoute) {
        var parentScope = parentRoute.scope;
        var parentDirective = parentRoute.getDirective();
        var childSpec = componentRoute.childSpec;

        if (childSpec.config) {
            if (parentDirective instanceof $Component) {
                parentScope.viewConfig = childSpec.config.call(parentScope);
            } else {
                throw new Error('In order to use config() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }

        if (childSpec.props) {
            if (parentDirective instanceof $Component) {
                angular.extend($scope, childSpec.props.call(parentScope));
            } else {
                throw new Error('In order to use props() for child routes,\n                    ' + parentRoute.getDirectiveTag() + ' must be instance of new\n                    style $Component');
            }
        }
    }
}

var $Component = exports.$Component = _core.$Class.extend('$Component', {

    onPopulate: angular.noop,

    init: function init() {
        var _this = this,
            _arguments = arguments;

        this.validate();

        this.name = _core.$util.dasherizeToCamel(this.tag);
        this.template = '<div class="' + this.tag + '-wrapper" ng-if="populated && display">' + this.template + '</div>';

        this.scope = this.scope || {};
        this.resolve = this.resolve || {};
        this.props = this.props || {};
        this.rootEvents = this.rootEvents || {};

        this.actions = this.actions || {};

        this.lifecycle = this.lifecycle || {};
        this.lifecycle.enter = this.lifecycle.enter || angular.noop;
        this.lifecycle.reenter = this.lifecycle.reenter || angular.noop;
        this.lifecycle.exit = this.lifecycle.exit || angular.noop;
        this.lifecycle.populate = this.lifecycle.populate || angular.noop;

        if (this.scope && Object.keys(this.scope).length) {

            if (this.props && Object.keys(this.props).length) {
                throw new Error('Can not defined scope and props on the same component');
            }

            this.scope.componentRoute = '=';
            this.scope['export'] = '@';

            this.props = _core.$util.map(this.scope, function (type, key) {
                return {
                    type: {
                        '=': 'var',
                        '@': 'str'
                    }[type],
                    required: false
                };
            });
        } else {

            this.props.componentRoute = {
                type: 'var',
                required: false
            };

            this.props['export'] = {
                type: 'str',
                required: false
            };

            this.scope = _core.$util.map(this.props, function (spec, key) {
                return {
                    'var': '=',
                    'str': '@'
                }[spec.type || 'var'];
            });
        }

        var originalController = this.controller || angular.noop;

        this.controller = function ($scope, $element) {
            $scope.$element = $element;

            $scope.$on('$destroy', function () {
                if ($scope.componentRoute && $scope.componentRoute.parent && $scope.componentRoute.parent.scope) {
                    delete $scope.componentRoute.parent.scope.viewConfig;
                }
                _this.lifecycle.exit.call($scope);
            });

            $scope.props = {};

            if ($scope.componentRoute) {
                setUpComponentRoute($scope, $Component, angular);
            }

            angular.forEach(_this.props, function (type, key) {

                var prop = _this.props[key];
                var required = prop.required !== false;
                var def = void 0;

                if (prop['default'] instanceof Function) {
                    def = _core.$util.memoize(prop['default'].bind($scope));
                } else {
                    def = function def() {
                        return prop['default'];
                    };
                }

                var UNDEFINED = {
                    'var': undefined,
                    str: ''
                }[prop.type];

                Object.defineProperty($scope.props, key, {
                    get: function get() {
                        var val = $scope[key];

                        if (val === UNDEFINED) {
                            if (required) {
                                throw new Error('Prop required for component :: ' + _this.tag + ' :: ' + key);
                            }

                            return def();
                        }

                        return val;
                    },

                    set: function set() {
                        throw new Error('Prop is immutable :: ' + _this.tag + ' :: ' + key);
                    }
                });
            });

            $scope.fields = {};

            $scope.actions = _core.$util.bindObject(_this.actions, $scope);

            Object.keys(_this.rootEvents).forEach(function (eventName) {
                var cancel = _core.$event.on(eventName, function (event) {
                    _this.rootEvents[eventName].apply($scope, _arguments);
                });

                $scope.$on('$destroy', cancel);
            });

            $scope.display = true;

            $scope.reload = function () {

                if (!$scope.populated) {
                    throw new Error('Can not reload unpopulated component');
                }

                $scope.display = false;
                setTimeout(function () {
                    $scope.display = true;
                });
            };

            $scope.componentScope = $scope;

            if ($scope.props['export'] && $scope.$parent.componentScope) {

                $scope.exports = angular.extend({}, _this.exports || {}, {
                    reload: $scope.reload
                });

                Object.defineProperty($scope.$parent.componentScope, $scope.props['export'], {
                    get: function get() {
                        return $scope.exports;
                    },

                    configurable: true
                });
            }

            $scope._enablePopulateEvents = true;

            _angular.$injector.invoke(originalController, _this, { $scope: $scope, $element: $element });
            _this.lifecycle.enter.call($scope);

            $scope._enablePopulateEvents = false;

            var cancelReEnterEvent = _core.$event.on('$stateChangeSuccess', function (event, toState) {
                if (toState === $scope.props.componentRoute) {
                    _this.lifecycle.reenter.call($scope);
                }
            });

            $scope.$on('$destroy', cancelReEnterEvent);

            return _core.$promise.sequential([function () {
                $scope.$emit('_populating');
            }, function () {
                return _core.$promise.map(_this.resolve, function (resolver, name, resolverPromises) {

                    if (angular.isObject(resolver)) {
                        $scope[name] = resolver;
                        return resolver;
                    }

                    return _core.$promise.resolve(resolver.call($scope, resolverPromises)).then(function (data) {
                        assertModelsRetrievedOrEmpty(data);

                        return _core.$promise.hash(data).then(function (resolvedData) {

                            $scope[name] = resolvedData;
                            return resolvedData;
                        });
                    });
                });
            }, function () {

                $scope.populated = true;

                $scope.$emit('_populated');

                _core.$event.refCount($scope, '_populating', '_populated').then(function () {

                    $scope.$on('populated', function (populatedEvent) {
                        populatedEvent.stopPropagation();
                    });

                    $scope.$emit('populated');
                    _this.onPopulate.call($scope);
                    _this.lifecycle.populate.call($scope);
                });
            }]);
        };
    },

    validate: function validate() {

        if (_core.$config.deploy.isLive() && !_core.$config.deploy.isTest()) {
            return;
        }

        var componentName = this.constructor.name;

        if (!this.tag) {
            throw new Error(componentName + ' :: expected property \'tag\'');
        }

        if (!this.tag.match(/^[a-z0-9-]+$/)) {
            throw new Error(componentName + ' :: tag should contain only lowercase alphanumeric characters and dashes');
        }

        if (!this.template) {
            throw new Error(componentName + ' :: expected property \'template\'');
        }

        if (this.resolve) {
            angular.forEach(this.resolve, function (resolver, name) {
                if (!(resolver instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'resolve.' + name + '\' to be a function');
                }
            });
        }

        if (this.props) {
            angular.forEach(this.props, function (prop, name) {

                if (!(prop instanceof Object)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '\' to be a function');
                }

                if (prop.type && ['var', 'str'].indexOf(prop.type) === -1) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.type\' to be one of var, str');
                }

                if (prop['default'] && prop.required) {
                    throw new Error(componentName + ' :: unnecessary \'props.' + name + '.default\', since prop is required');
                }

                if (prop['default'] && prop['default'] instanceof Object && !(prop['default'] instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'props.' + name + '.default\' to be a primitive or a function - please do not pass mutable objects');
                }
            });
        }

        if (this.actions) {
            angular.forEach(this.actions, function (action, name) {
                if (!(action instanceof Function)) {
                    throw new Error(componentName + ' :: expected \'actions.' + name + '\' to be a function');
                }
            });
        }

        if (this.lifecycle) {
            Object.keys(this.lifecycle).forEach(function (name) {
                if (['enter', 'populate', 'exit', 'reenter'].indexOf(name) === -1) {
                    throw new Error(componentName + ' :: unexpected \'lifecycle.' + name + '\'');
                }
            });
        }
    }
});

$Component.reopenClass({

    extend: function extend() {

        var SubClass = _core.$Class.extend.apply(this, arguments);
        var spec = new SubClass();

        angular.module().directive(spec.name, function () {
            return spec;
        });

        return SubClass;
    },

    render: function render(scope) {

        _core.$Model.clearCache();
        _core.$Api.clearCache();

        _core.$event.emit('$resetState');
        (0, _locale.$flushContent)();

        var $scope = _angular.$rootScope.$new();

        angular.extend($scope, scope);

        var attrs = Object.keys(scope).map(function (key) {
            return _core.$util.camelToDasherize(key) + '="' + (this.prototype.props[key].type === 'var' ? key : scope[key]) + '"';
        }.bind(this)).join(' ');

        var cleanRootScope = (0, _ng.$cleanRootScope)(_angular.$rootScope);
        var html = '<' + this.prototype.tag + ' ' + attrs + '></' + this.prototype.tag + '>';

        console.log('RENDER', html, scope);

        var element = (0, _angular.$compile)(html)($scope);

        afterEach(_core.$util.once(function () {
            $scope.$destroy();
            cleanRootScope();
        }));

        setTimeout.flush();

        element.isolateScope = function () {
            throw new Error('Please test this element by interfacing with its public api: define mock endpoints, and interact with html links, buttons and form fields');
        };

        return element;
    }
});

function autoConvertDirectiveToComponent(_ref, original) {
    var name = _ref[0],
        factory = _ref[1];


    if (!angular.isFunction(factory)) {
        return original();
    }

    var tag = _core.$util.camelToDasherize(name);
    var spec = _angular.$injector.invoke(factory);

    if (spec.controller) {
        (function () {
            var originalController = spec.controller;

            spec.controller = function ($scope, $element) {
                $scope._enablePopulateEvents = true;
                var result = _angular.$injector.invoke(originalController, this, { $scope: $scope, $element: $element });

                $scope._enablePopulateEvents = false;
                return result;
            };
        })();
    }

    if (spec instanceof $Component || !spec.template || !spec.controller || name.indexOf('xo') !== 0 || spec.transclude) {
        return original(this, [name, function () {
            return spec;
        }]);
    }

    if (spec.componentize) {

        $Component.extend('$' + name + 'Component', spec, {
            tag: tag
        });

        return this;
    }

    return original(this, [name, function () {
        return spec;
    }]);
}

_core.$util.monkeyPatch(_angular.$compileProvider, 'directive', autoConvertDirectiveToComponent);
_core.$util.monkeyPatch(angular.module(), 'directive', autoConvertDirectiveToComponent);

// $populate needs to go away

function $populate($scope, instances) {

    $scope.$on = $scope.$on || angular.noop;
    $scope.$emit = $scope.$emit || angular.noop;

    var _enablePopulateEvents = $scope._enablePopulateEvents;

    if (_enablePopulateEvents) {
        _core.$event.refCount($scope, '_populating', '_populated').then(function () {
            $scope.$emit('populated');
        });
    }

    $scope.$on('populated', function (populatedEvent) {
        populatedEvent.stopPropagation();
    });

    if (_enablePopulateEvents) {
        $scope.$emit('_populating');
    }

    return _core.$promise.all(_core.$util.map(instances, function (instance, name) {

        var promise = void 0;

        if (instance.then) {
            promise = instance;
        } else {
            promise = instance.retrieve();
            $scope[name] = instance;
        }

        return promise.then(function (result) {
            $scope[name] = result;
            return result;
        });
    })).then(function (result) {

        if (_enablePopulateEvents) {
            $scope.$emit('_populated');
        }

        return result;
    });
}

angular.value("$Component", $Component);
angular.value("$populate", $populate);
_angular.$rootScope;

_angular.$compile;

_angular.$injector;

_angular.$compileProvider;

_core.$Class;

_core.$Model;

_core.$Api;

_core.$util;

_core.$promise;

_core.$config;

_core.$event;

_locale.$flushContent;

_ng.$cleanRootScope;

_directive.$registerDirective;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/ng/component.js
// module id = ./components/squid/dist/ng/component.js
// module chunks = 1